import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import "./AskQuestion.css";                    // ⬅︎ new (tiny) overrides
import { submitQuestion } from "../Api";  // Adjust path if needed

export default function AskQuestion() {
  const [name,     setName]     = useState("");
  const [email,    setEmail]    = useState("");
  const [question, setQuestion] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [sent,       setSent]     = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
  
    try {
      await submitQuestion({ name, email, question });
      setSent(true);
    } catch (error) {
      alert(error.message); // Or display it more nicely
      console.error("Submission error:", error);
    } finally {
      setIsSending(false);
    }
  };
  

  return (
    <div className="app-container">
      <Sidebar />

      <main className="main-section">
        <div className="page-card ask-card">
          <h1>Tell us about your problem</h1>

          {!sent ? (
            <form className="ask-form" onSubmit={handleSubmit}>
              <label className="dropdown-label">Name</label>
              <input
                className="camera-input"
                placeholder="Jane Doe"
                value={name}
                onChange={e=>setName(e.target.value)}
                required
              />

              <label className="dropdown-label">Email</label>
              <input
                type="email"
                className="camera-input"
                placeholder="jane@company.com"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                required
              />

              <label className="dropdown-label">Describe the challenge</label>
              <textarea
                className="camera-textarea"
                placeholder="What are you trying to achieve or measure?"
                value={question}
                onChange={e=>setQuestion(e.target.value)}
                rows={6}
                required
              />

              <button className="next-button" disabled={isSending}>
                {isSending ? "Sending…" : "Send"}
              </button>
            </form>
          ) : (
            <div className="thanks">
              <h2>Thank you!</h2>
              <p>
                We’ve received your message and will get back to you at
                <br /><strong>{email}</strong> as soon as possible.
              </p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
